import * as React from 'react';
import { Query } from 'react-apollo';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { QueryFilter, QUERY_FILTER_PUBLISHER } from '../../../../shared';
import { client } from 'src';

export interface IPublisherDateFilterEntity {
  initialDate: any;
  endDate: any;
}

import { CurrentDate, SomeDaysAgo } from '../../../../../services';
import { MetricIndex, FilterCategoryType, GoogleAnalytics } from '../../../../../services/GoogleAnalytics';

const ga = new GoogleAnalytics();

// tslint:disable-next-line:no-empty-interface
export interface IPublisherDateFilterProps {
    finishLoad(): void;
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherDateFilterState {
  dialogOpen: boolean,
  customFilter: {
    isChart: boolean,
  },
  endDate: any,
  endDateFilterChecked: any;
  initialDate: any,
  initialDateFilterChecked: any;
}

export class PublisherDateFilter extends React.Component<IPublisherDateFilterProps, IPublisherDateFilterState> {
  constructor(props: IPublisherDateFilterProps) {
    super(props);

    const finalDate = CurrentDate();
    const initDate = SomeDaysAgo(32);

    this.state = {
      customFilter: {
        isChart: false,
      },
      dialogOpen: false,
      endDate: finalDate,
      endDateFilterChecked: {},
      initialDate: initDate,
      initialDateFilterChecked: {},
    }

  }

  public componentDidMount () {
    // tslint:disable-next-line:no-string-literal
    const endDateFilterChecked = client.cache['data'].data.ROOT_QUERY.FILTER_endDateFilterChecked;
    // tslint:disable-next-line:no-string-literal
    const initialDateFilterChecked = client.cache['data'].data.ROOT_QUERY.FILTER_initialDateFilterChecked;
    if(endDateFilterChecked == null || endDateFilterChecked === undefined || endDateFilterChecked.length <= 0
        || initialDateFilterChecked == null || initialDateFilterChecked === undefined || initialDateFilterChecked.length <= 0) {
        client.writeData({ data: { endDateFilterChecked: this.state.endDate, initialDateFilterChecked: this.state.initialDate } });
        client.writeData({ data: { FILTER_endDateFilterChecked: this.state.endDate, FILTER_initialDateFilterChecked: this.state.initialDate } });
        QueryFilter.updateMutationPublisher();
    }
    this.props.finishLoad();
  }

  public render() {

    return (<Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true}  >
      {({ loading: loadingC, error: errorC, data: cache, client: clientC }) => (
            <div className="filter-item">
              <Button variant="contained" onClick={this.handleDialogOpen}>
                <DateRangeIcon className="filter-item-icon" /><div className="filter-label">Data</div>
              </Button>
              <Dialog
                open={this.state.dialogOpen}
                onClose={this.handleDialogClose}
                aria-labelledby="economic-group-dialog-title"
                aria-describedby="alereconomic-group-dialog-description"
                className="filter-dialog"
              >
                <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">{"Data"}</DialogTitle>
                <DialogContent className="filter-dialog-content">
                    <TextField
                        defaultValue={this.state.initialDate}
                        onChange={this.handleChangeDate('initialDate')}
                        id="initialDate"
                        label="Data inicial"
                        type="date"
                        required={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        defaultValue={this.state.endDate}
                        onChange={this.handleChangeDate('endDate')}
                        id="endDate"
                        label="Data final"
                        type="date"
                        required={true}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </DialogContent>
                <DialogActions className="filter-actions">
                  <Button className="filter-dialog-clear" onClick={this.handleDialogClear} >
                    Limpar
              </Button>
                  <Button className="filter-dialog-close" onClick={this.handleDialogClose} >
                    Fechar
              </Button>
                  <Button className="filter-dialog-apply" onClick={this.handleDialogApply.bind(this, clientC)} autoFocus={true}>
                    Aplicar
              </Button>
                </DialogActions>
              </Dialog>
            </div>
      )}
    </Query>)
  }

  private handleDialogOpen = () => {
    this.setState({ dialogOpen: true });
  };

  private handleDialogClose = () => {
    this.setState({ dialogOpen: false});
  };

  // tslint:disable-next-line:no-shadowed-variable
  private handleDialogApply = (client: any) => {
    client.writeData({ data: { endDateFilterChecked: this.state.endDate, initialDateFilterChecked: this.state.initialDate } });
    client.writeData({ data: { FILTER_endDateFilterChecked: this.state.endDate, FILTER_initialDateFilterChecked: this.state.initialDate } });
    QueryFilter.updateMutationPublisher();
    this.setState({ dialogOpen: false });
    const metricName = 'metric'+MetricIndex.FILTER;
    ga.fireEventTracking(FilterCategoryType.DATE, 'filter', 'publisher-date', false, metricName);

  }

  private handleDialogClear = () => {
    this.setState({
        endDate: '',
        initialDate: '',
    });
  }

    private handleChangeDate = (param: any) => (event: React.FormEvent<HTMLInputElement>) => {

        if(param==='endDate') {
            let endDate = Object.assign({}, this.state.endDate);
            endDate = event.currentTarget.value;
            this.setState({ endDate });
        } else if (param === 'initialDate') {
            let initialDate = Object.assign({}, this.state.initialDate);
            initialDate = event.currentTarget.value;
            this.setState({ initialDate });
        }
    };

}



// WEBPACK FOOTER //
// ./src/component/publisher/shared/filter/publisher-date-filter/PublisherDateFilter.tsx